import Vue from "vue";
import Vuex from "vuex";

// import axios from "axios";
// import AppConfig from "../../../AppConfig";
// import NODE_ENV from "../../../env";

// const baseURL = AppConfig[NODE_ENV]["apiGatewayBookings"];

Vue.use(Vuex);

export default {
    state: {
        sender: {},
        recievers: [],
        recieverPackages: [],
        activeTab: 1,
        bookingPayloadSchema: [],
        createdShipment: {},
        newBookingPaymentType: "",
        newShippingMethod: "",
        quoteStatus: undefined,
        isInterState: true,
        activeShippingService: {},
        createdBookingPayload: {}
    },
    getters: {
        getCreatedBookingPayload: (state) => {
            return state.createdBookingPayload;
        },
        getNewQuoteStatus: (state) => {
            return state.quoteStatus;
        },
        getSavedNewSender: (state) => {
            return state.sender;
        },
        getSavedNewRecievers: (state) => {
            return state.recievers;
        },
        getSavedNewRecieverPackage: (state) => {
            return state.recieverPackages;
        },
        getActiveTab: (state) => {
            return state.activeTab;
        },
        getBookingPayloadSchema: (state) => {
            return state.bookingPayloadSchema;
        },
        getCreatedBooking: (state) => {
            return state.createdShipment;
        },
        getNewBookingpaymenttype: (state) => {
            return state.newBookingPaymentType;
        },
        getNewBookingShippingMethod: (state) => {
            return state.newShippingMethod;
        },
        getIsInterState: (state) => {
            return state.isInterState;
        },
        getActiveShippingService: (state) => {
            return state.activeShippingService;
        }
    },
    mutations: {
        RESET_BOOKING_STATE(state) {
            state.sender = {};
            state.recievers = [];
            state.recieverPackages = [];
            state.activeTab = 1;
            state.bookingPayloadSchema = [];
            state.createdShipment = {};
            state.newBookingPaymentType = "";
            state.quoteStatus = undefined;
            state.isInterState = false;
            state.activeShippingService = {};
            state.createdBookingPayload = {}
        },
         SET_CREATED_BOOKING_PAYLOAD(state, Payload) {
            state.createdBookingPayload = Payload;
        },
        SET_SAVED_QUOTE_STATUS(state, Payload) {
            state.quoteStatus = Payload;
        },
        SET_SAVED_NEW_SENDER(state, Payload) {
            state.sender = Payload;
        },
        SET_SAVED_NEW_RECIEVERS(state, Payload) {
            state.recievers = Payload;
        },
        SET_SAVED_NEW_RECIEVER_PACKAGES(state, Payload) {
            state.recieverPackages = Payload;
        },
        SET_SAVED_ACTIVE_TAB(state, Payload) {
            state.activeTab = Payload;
        },
        SET_SAVED_BOOKING_PAYLOAD_SCHEMA(state, Payload) {
            state.bookingPayloadSchema = Payload;
        },
        SET_CREATED_BOOKING(state, Payload) {
            state.createdShipment = Payload;
        },
        SET_NEW_BOOKING_PAYMENT_TYPE(state, Payload) {
            state.newBookingPaymentType = Payload;
        },
        SET_NEW_BOOKING_SHIPMENT_TYPE(state, Payload) {
            state.newShippingMethod = Payload;
        },
        SET_IS_INTER_STATE(state, Payload) {
            state.isInterState = Payload;
        },
        SET_ACTIVE_SHIPPING_SERVICE(state, Payload) {
            state.activeShippingService = Payload;
        },
    },

    actions: {
        resetState({ commit }) {
            commit("RESET_BOOKING_STATE");
        },
        setSavedNewSender({ commit }, payload) {
            commit("SET_SAVED_NEW_SENDER", payload);
        },
        setSavedNewRecievers({ commit }, payload) {
            commit("SET_SAVED_NEW_RECIEVERS", payload);
        },
        setSavedNewRecieverPackages({ commit }, payload) {
            commit("SET_SAVED_NEW_RECIEVER_PACKAGES", payload);
        },
        setSavedActiveTab({ commit }, payload) {
            commit("SET_SAVED_ACTIVE_TAB", payload);
        },
        setSavedBookingPayloadSchema({ commit }, payload) {
            commit("SET_SAVED_BOOKING_PAYLOAD_SCHEMA", payload);
        },
        setSavedCreatedShipment({ commit }, payload) {
            commit("SET_CREATED_BOOKING", payload);
        },
        setNewBookingpaymenttype({ commit }, payload) {
            commit("SET_NEW_BOOKING_PAYMENT_TYPE", payload);
        },
        setNewBookingShipmentMethod({ commit }, payload) {
            commit("SET_NEW_BOOKING_SHIPMENT_TYPE", payload);
        },
        setNewBookingQuoteStatus({ commit }, payload) {
            commit("SET_SAVED_QUOTE_STATUS", payload);
        },
        setNewBookingIsInterState({ commit }, payload) {
            commit("SET_IS_INTER_STATE", payload);
        },
        setActiveShippingService({ commit }, payload) {
            commit("SET_ACTIVE_SHIPPING_SERVICE", payload);
        },
        setCreatedBookingPayload({ commit }, payload) {
            commit("SET_CREATED_BOOKING_PAYLOAD", payload);
        }
    },
};
